import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScribblerLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3077 71.5857C16.6404 71.6175 17.6485 70.9382 18.027 70.7324C22.6613 68.0978 28.7821 64.4742 34.261 60.9402L16.6284 54.5513C15.7259 54.2318 14.8581 53.9686 14.8765 54.3015C15.1471 59.1867 15.5218 71.5857 16.3077 71.5857Z",
			fill: "url(#paint0_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.795 51.5617C48.3844 52.1596 21.8608 68.8393 18.027 70.7324C17.6485 70.9559 16.4404 71.6752 16.298 71.5766C16.298 71.5766 21.7291 74.8343 24.0317 76.267C29.1245 79.4356 32.0637 81.3925 36.0987 78.7977L48.367 70.9079C51.2976 69.0233 52.2678 62.9748 51.8685 58.8081C51.451 54.4509 48.9015 51.4066 48.795 51.5617Z",
			fill: "url(#paint1_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6046 28.2474C31.5182 28.2977 31.5206 28.3813 31.4344 28.4312C26.2935 31.5364 19.7268 33.6628 16.7376 39.7662C18.9653 41.1793 19.7234 41.443 20.555 41.768C31.8075 46.1657 48.4526 51.0744 48.8559 51.6267C55.5345 47.0792 60.9578 42.9147 63.2354 40.4114C63.2428 40.4188 63.2507 40.4265 63.2583 40.4342C60.716 37.4355 56.8268 36.9508 50.2476 34.5871C43.9711 32.6445 37.5155 30.3633 31.6046 28.2474Z",
			fill: "url(#paint2_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.248 8.04559C64.3964 6.96497 55.3189 12.6781 46.2569 18.9058C51.3194 20.4128 60.6434 23.7935 63.4774 24.4335C63.9681 24.5443 64.4101 24.6359 64.3721 24.4855C64.3637 18.9602 64.248 8.04559 64.248 8.04559Z",
			fill: "url(#paint3_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2213 11.1117C26.1602 13.7974 18.5345 17.685 15.4622 22.0595C11.5775 27.5907 12.4954 37.0029 16.7711 39.7852C16.7306 38.7583 30.321 29.0923 31.7196 28.2784C30.4123 27.4495 24.947 23.0869 30.2213 11.1117Z",
			fill: "url(#paint4_linear_4169_71570)",
			fillOpacity: .992157
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1801 11.1431C30.1801 11.1431 39.4226 4.6316 45.2227 1.37414C47.3831 0.160816 48.7146 0.0215628 49.373 0.00095245C51.5234 -0.0663515 56.4196 3.44906 60.1477 5.54829C62.4126 6.82367 64.2093 7.85135 64.208 7.93507C62.7412 7.8338 32.149 28.4541 31.7108 28.2837C22.9134 24.9465 30.1801 11.1431 30.1801 11.1431Z",
			fill: "url(#paint5_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2583 40.4343L63.2355 40.4115C60.9578 42.9147 55.4611 47.0314 48.7825 51.5789C51.2135 54.4989 52.1278 58.3239 51.9109 61.7569C51.4573 68.936 48.7814 70.5034 48.7509 70.6298C58.1687 64.4068 63.741 61.414 65.7184 57.0526C68.0491 51.9119 67.1845 44.3713 63.2583 40.4343Z",
			fill: "url(#paint6_linear_4169_71570)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4169_71570",
				x1: 15.8963,
				y1: 55.5692,
				x2: 24.8879,
				y2: 68.2973,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#00993C",
					stopOpacity: .992157
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .778481,
					stopColor: "#004C2C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4169_71570",
				x1: 20.2977,
				y1: 81.7685,
				x2: 48.8812,
				y2: 51.9097,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .336437,
					stopColor: "#007541",
					stopOpacity: .988235
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00BCA1",
					stopOpacity: .992157
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4169_71570",
				x1: 17.4371,
				y1: 36.8376,
				x2: 62.2781,
				y2: 41.4962,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .131279,
						stopColor: "#005562"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49789,
						stopColor: "#007678",
						stopOpacity: .992157
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#0098A6",
						stopOpacity: .992157
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_4169_71570",
				x1: 53.2148,
				y1: 9.16703,
				x2: 64.0309,
				y2: 24.5486,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .359112,
					stopColor: "#003763",
					stopOpacity: .992157
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00649C",
					stopOpacity: .984314
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_4169_71570",
				x1: 17.17,
				y1: 37.6457,
				x2: 28.4707,
				y2: 11.9241,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#006194",
						stopOpacity: .992157
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .532245,
						stopColor: "#00A1FD",
						stopOpacity: .996078
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#008AD6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_4169_71570",
				x1: 28.021,
				y1: 25.7709,
				x2: 58.6187,
				y2: -.0232521,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .14968,
						stopColor: "#006AA8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .377637,
						stopColor: "#0072BD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .818565,
						stopColor: "#00589D"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_4169_71570",
				x1: 49.7715,
				y1: 58.5381,
				x2: 67.4746,
				y2: 46.0821,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .259494,
						stopColor: "#00BE9F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .527272,
						stopColor: "#00B298"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .862869,
						stopColor: "#00A5A8"
					})
				]
			})
		] })
	]
});
export default SvgScribblerLogo;
